import { render, staticRenderFns } from "./MetricsMain.vue?vue&type=template&id=61cd937e&scoped=true"
import script from "./MetricsMain.vue?vue&type=script&lang=js"
export * from "./MetricsMain.vue?vue&type=script&lang=js"
import style0 from "./MetricsMain.vue?vue&type=style&index=0&id=61cd937e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd937e",
  null
  
)

export default component.exports